import {Collection, Director, EntityTimeInterface, TimeFormat, TimeFormatInterface} from "./Main";
import {TaskBuilder, TaskInterface} from "./Task";
import {LabelBuilder, LabelInterface} from "./Labels";
import {ProjectBuilder, ProjectInterface} from "./Projects";
import {TodoistSync} from "./TodoistSync";
import {sync} from "glob";
import {ColorTypeInterface, ColorTypeSingleton} from "./Color";
import {Priority} from "./Priority";
import {SectionBuilder, SectionInterface} from "./Section";

export interface TodoistApp {

    tasks: Collection<TaskInterface>,
    labels: Collection<LabelInterface>,
    projects: Collection<ProjectInterface>
    sections: Collection<SectionInterface>


}


export class SyncConverter {

    constructor(private sync: TodoistSync.SyncInterface) {

    }

    convert(): TodoistApp {

        let labels = (new Director(this.sync.labels, new LabelBuilder())).getResults();
        let projects = (new Director(this.sync.projects, new ProjectBuilder({props: {projects: this.sync.projects}}))).getResults();
        let sections = (new Director(this.sync.sections, new SectionBuilder())).getResults();

        let tasks = (new Director(this.sync.items, new TaskBuilder({
            props: {
                labels: labels,
                projects: projects,
                sections: sections
            }
        }))).getResults();




        tasks.getItems().forEach(item => {

            let childTasks = tasks.filter( childItem => {
                return childItem.getParentId() == item.getId()
            });

            childTasks.getItems().forEach(childItem => {
                item.addChildTask(childItem);
            })


        });

        return {tasks: tasks, labels: labels, projects: projects, sections: sections}

    }


}


export class CollectionHelper {


    static sumTime(collection: Collection<EntityTimeInterface>): TimeFormatInterface{
        let time = collection.sum(function (item) {
            return Number(item.getTime())
        });
        return new TimeFormat(time);
    }


}

export class TaskStatistic{

    constructor(private tasks: Collection<TaskInterface>) {}

    getFullTime(){
        return CollectionHelper.sumTime(this.tasks);
    }

    getTypeTime(): {color: ColorTypeInterface, time: TimeFormatInterface}[] {
        let groupsColor = this.tasks.group<ColorTypeInterface>(item => item.getColor());
        return  groupsColor.getItems().map((item) => {return {color:item.group, time: CollectionHelper.sumTime(item.items)}})


    }


}